module.exports = "https://cdn.realtymogul.com/static/media/icon_opportunistic.8ff40ff1.svg";